import { MDSTextVariant } from "@/mds/components/text/text/text.types";

export const MDSFontSizes = {
  [MDSTextVariant.HeaderXl]: "36px",
  [MDSTextVariant.HeaderL]: "28px",
  [MDSTextVariant.HeaderM]: "22px",
  [MDSTextVariant.HeaderS]: "20px",
  [MDSTextVariant.TextM]: "18px",
  [MDSTextVariant.TextSm]: "15px",
  [MDSTextVariant.TextS]: "14px",
  [MDSTextVariant.TextXs]: "12px",
  [MDSTextVariant.ParagraphSm]: "15px",
  [MDSTextVariant.ParagraphS]: "14px",
  [MDSTextVariant.CodeTextSm]: "15px",
  [MDSTextVariant.CodeParagraphSm]: "15px",
};

export const MDSLineHeights = {
  [MDSTextVariant.HeaderXl]: "40px",
  [MDSTextVariant.HeaderL]: "36px",
  [MDSTextVariant.HeaderM]: "30px",
  [MDSTextVariant.HeaderS]: "28px",
  [MDSTextVariant.TextM]: "20px",
  [MDSTextVariant.TextSm]: "16px",
  [MDSTextVariant.TextS]: "16px",
  [MDSTextVariant.TextXs]: "16px",
  [MDSTextVariant.ParagraphSm]: "22px",
  [MDSTextVariant.ParagraphS]: "20px",
  [MDSTextVariant.CodeTextSm]: "16px",
  [MDSTextVariant.CodeParagraphSm]: "22px",
};

export const MDSLineSpacings = {
  [MDSTextVariant.HeaderXl]: "-0.01em",
  [MDSTextVariant.HeaderL]: "-0.01em",
  [MDSTextVariant.HeaderM]: "-0.01em",
  [MDSTextVariant.HeaderS]: "-0.01em",
  [MDSTextVariant.TextM]: "normal",
  [MDSTextVariant.TextSm]: "normal",
  [MDSTextVariant.TextS]: "normal",
  [MDSTextVariant.TextXs]: "normal",
  [MDSTextVariant.ParagraphSm]: "normal",
  [MDSTextVariant.ParagraphS]: "normal",
  [MDSTextVariant.CodeTextSm]: "normal",
  [MDSTextVariant.CodeParagraphSm]: "normal",
};

export const MDSFontWeights = {
  regular: 400,
  medium: 500,
  smedium: 550,
  semiBold: 600,
  bold: 700,
  extrabold: 800,
};

export const MDSSpacings = {
  ["0"]: "0px",
  ["0.5"]: "2px",
  ["1"]: "4px",
  ["2"]: "8px",
  ["3"]: "12px",
  ["4"]: "16px",
  ["5"]: "20px",
  ["6"]: "24px",
  ["7"]: "28px",
  ["8"]: "32px",
  ["9"]: "36px",
  ["10"]: "40px",
};

export type IMDSFontSizes = typeof MDSFontSizes;
export type IMDSLineHeights = typeof MDSLineHeights;
export type IMDSLineSpacings = typeof MDSLineSpacings;
export type IMDSFontWeights = typeof MDSFontWeights;
export type IMDSSpacings = typeof MDSSpacings;
